import $http from '../connectionProxy'

export const getTraysByStudent = ({ studentId, startDate, endDate }) => {
  return $http.get(`/responsibles_area/meals/trays?student_id=${studentId}&start_date=${startDate}&end_date=${endDate}`)
}
